import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_CERTIFICATIONS,
  GET_CERTIFICATIONS_SUCCESS,
  ADD_CERTIFICATION,
  ADD_CERTIFICATION_SUCCESS,
  UPDATE_CERTIFICATION,
  UPDATE_CERTIFICATION_SUCCESS,
  DELETE_CERTIFICATION,
  DELETE_CERTIFICATION_SUCCESS
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// Api  functions.

function getCertifications() {
  // Api call.
  const response = api.certifications().getAllCertifications();
  return response;
}
//add Certification.
function addCertificationApi(formData) {
  // api for add Certification.
const response=  api.certifications().AddEditProjectCertification(formData);
return response;
}

function updateCertificationApi(formData) {
  // api for update Certification.
  api.certifications().AddEditProjectCertification(formData);
}
function delCertificationApi(delId) {
  // api for delete Certification
  const response = api.certifications().DeleteCertification(delId);
  return response;
}

// handle function.
// get all certifications.
export function* handleGetCertifications() {
  try {
    const response = yield call(getCertifications);
    yield put({ type: GET_CERTIFICATIONS_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
// add Certification.
export function* handleAddCertification({ payload }) {
  try {
    const response= yield call(addCertificationApi, payload);
    payload={...payload,"certificationId" :response.data};
    yield put({ type: ADD_CERTIFICATION_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleUpdateCertification({ payload }) {
  try {
    yield call(updateCertificationApi, payload);
    yield put({ type: UPDATE_CERTIFICATION_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDelCertification({ payload }) {
  try {
    yield call(delCertificationApi, payload);
    yield put({ type: DELETE_CERTIFICATION_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
// Certifications watch function.
export function* certificationWatchFun() {
  yield takeLatest(GET_CERTIFICATIONS, handleGetCertifications);
  yield takeLatest(ADD_CERTIFICATION,handleAddCertification); 
  yield takeLatest(UPDATE_CERTIFICATION, handleUpdateCertification);
  yield takeLatest(DELETE_CERTIFICATION, handleDelCertification);
}
